import script from "./NoticeDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticeDetail.vue?vue&type=script&setup=true&lang=js"

import "./NoticeDetail.vue?vue&type=style&index=0&id=00204f9c&lang=scss"

const __exports__ = script;

export default __exports__